import {MutationTree} from "vuex";
import * as moment from "moment";
import Locale from '../../Locales/ts/Locale';
import ApiClient from "../ts/ApiClient";

export const mutations: MutationTree<any> = {

    setSettingsLoading(state: any, payload: boolean) {
        state.settingsLoading = payload;
    },

    setSettingsSaving(state: any, payload: boolean) {
        state.settingsSaving = payload;
    },

    saveSettings(state: any, settings: boolean) {
        state.settings = settings;
        state.settingsExpire = moment().add(15, 'minutes');
    },

    saveIntegrations(state: any, integrations: Array<any>) {
        state.settings.integrations = integrations;
    },

    bustSettingsCache(state: any, payload: boolean) {
        state.settingsExpire = null;
    },

    enableLocale(state: any, locale: Locale) {
        state.settings.locales.push(locale);
    },

    disableLocale(state: any, locale: Locale) {
        const index = state.settings.locales.findIndex ( (panelLocale: Locale) => panelLocale.id === locale.id);
        state.settings.locales.splice(index,1);
    },

    setApiClients(state: any, payload: any) {
        state.apiClients = payload;
    },

    addApiClient(state: any, payload: any) {
        state.apiClients.push(payload);
    },

    deleteApiClient(state: any, id: number) {
        const index = state.apiClients.findIndex((client: ApiClient) => client.id === id);
        state.apiClients.splice(index, 1);
    },
};
